import React, { createContext, useState } from "react"

export const PopupsContext = createContext({})

export const PopupsProvider = ({ children }) => {
  const [popupSectionId, openModalSectionById] = useState(null)
  const [isModalOpen, setModal] = useState(false)

  return (
    <div>
      <PopupsContext.Provider
        value={{ popupSectionId, openModalSectionById, isModalOpen, setModal }}
      >
        {children}
      </PopupsContext.Provider>
    </div>
  )
}
